/**
 * Array mapping of all skill data that is mapped in ./skills
 */
import React from 'react';
import { 
  SiJavascript,
  SiTypescript,
  SiReact,
  SiRedux,
  SiStyledcomponents,
  SiBootstrap,
  SiMaterialui,
  SiFigma,
  SiAmazonaws,
  SiPython,
  SiDjango,
  SiPostman,
  SiPostgresql,
  SiVisualstudio,
  SiGatsby,
  SiJira,
  SiGit
  } from "react-icons/si";

import {
  IoLogoVercel
} from 'react-icons/io5'

const skillData = [
  {
    'element':<SiJavascript/>, 
    'label' : 'JavaScript',
    'skillThemeColor': '#EFD81D',
    'description' : 'What this site is written in!',
  },
  {
    'element':<SiTypescript/>, 
    'label' : 'TypeScript',
    'skillThemeColor': '#2F74C0',
    'description' : 'Type checking is pretty cool',
  },
  {
    'element':<SiReact/>, 
    'label' : 'React',
    'skillThemeColor': '#61DAFB',
    'description' : 'What this site is built with!',
  },
  {
    'element':<SiRedux/>, 
    'label' : 'Redux',
    'skillThemeColor': '#7E55C0',
    'description' : 'Cool React state management',
  },
  {
    'element':<SiStyledcomponents/>, 
    'label' : 'Styled-Components',
    'skillThemeColor': '#DE82C4',
    'description' : 'Makes my code pretty',
  },
  {
    'element':<SiGatsby/>, 
    'label' : 'Gatsby',
    'skillThemeColor': '#663399',
    'description' : 'What this site uses!',
  },
  {
    'element':<SiBootstrap/>, 
    'label' : 'Bootstrap',
    'skillThemeColor': '#61DAFB',
    'description' : 'Speedy frontend development',
  },
  {
    'element':<SiMaterialui/>, 
    'label' : 'Material UI',
    'skillThemeColor': '#00B0FF',
    'description' : 'What this site uses!',
  },
  {
    'element':<SiFigma/>, 
    'label' : 'Figma',
    'skillThemeColor': '#C7B9FF',
    'description' : 'What I use to prototype',
  },
  {
    'element':<SiAmazonaws/>,
    'label' : 'AWS',
    'skillThemeColor': '#EC912D',
    'description' : 'Amplify, Lambda, DynamoDB, API-Gateway',
  },
  {
    'element':<IoLogoVercel/>,
    'label' : 'Vercel',
    'skillThemeColor': '#FFFFFF',
    'description' : 'My favourite way to deploy apps 🤍',
  },
  {
    'element':<SiPython/>, 
    'label' : 'Python',
    'skillThemeColor': '#366C9C',
    'description' : 'For all things are possible',
  },
  {
    'element':<SiDjango/>, 
    'label' : 'Django',
    'skillThemeColor': '#44B78B',
    'description' : 'Django Rest Framework',
  },
  {
    'element':<SiPostman/>, 
    'label' : 'Postman',
    'skillThemeColor': '#F56933',
    'description' : 'For REST API development',
  },
  {
    'element':<SiPostgresql/>, 
    'label' : 'SQL',
    'skillThemeColor': '#31648C',
    'description' : 'Databasing is awesome!',
  },
  {
    'element':<SiVisualstudio/>, 
    'label' : 'VSCode',
    'skillThemeColor': '#0076C6',
    'description' : 'IDE I use',
  },
  {
    'element':<SiJira />,
    'label' : 'Jira',
    'skillThemeColor': '#176FE5',
    'description' : 'Agile for life',
  },
  {
    'element':<SiGit/>,
    'label' : 'Git',
    'skillThemeColor': '#E84E31',
    'description' : 'Version control is key!',
  }
]
export default skillData;